<script>
import _ from 'lodash'
import PatientService from '@/request/patient/patient'
import PositionService from '@/request/dictionary/position'
export default {
  name: 'PatientEdit',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data () {
    let idCardValidity = (rule, code, callback) => {
      var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
      var tip = ""
      var pass = true
      if (!code ) {
        callback()
      } else if (!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误"
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误"
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split('')
          if (code[code.length -1] === 'x') {
            code[code.length -1] = 'X'
          }
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          var last = parity[sum % 11];
          if (last != code[17]) {
            tip = "校验位错误"
            pass = false
          }
        }
      }
      if (!pass) {
        callback(new Error(tip))
      } else {
        callback()
      }
    }
    return {
      patientSaving: false,
      positionSelection: [],
      patientRules: {
        name: [{ required: true, message: '患者姓名不能为空' }],
        age: [{ type: 'number', max: 200, required: false, message: '年龄输入不正确'}],
        identity: [{validator: idCardValidity, required: false}]
      },
      editPatient: {
        positions: []
      }
    }
  },
  created: function () {
    this.init()
  },
  mounted: function () {},
  beforeDestroy () {},
  watch: {
    value () {
      this.init()
    },
    'editPatient.positions': function (val) {
      if (_.isEmpty(val)) {
        if (_.isEmpty(this.positionSelection)) {
          this.listPosition()
        }
        return
      }
      this.listPosition(null, null, val, 0)
    }
  },
  methods: {
    init () {
      if (_.isEmpty(this.value)) {
        this.editPatient = {
          positions: []
        }
        return
      }
      this.editPatient = _.cloneDeep(this.value)
      let ps = []
      if (this.editPatient.provinceSn) {
        ps.push(this.editPatient.provinceSn)
      }
      if (this.editPatient.citySn && ps.length === 1) {
        ps.push(this.editPatient.citySn)
      }
      if (this.editPatient.countySn && ps.length === 2) {
        ps.push(this.editPatient.countySn)
      }
      if (this.editPatient.townsSn && ps.length === 3) {
        ps.push(this.editPatient.townsSn)
      }
      if (this.editPatient.villageSn && ps.length === 4) {
        ps.push(this.editPatient.villageSn)
      }
      this.$set(this.editPatient, 'positions', _.clone(ps))
    },
    handleCancelEditPatient () {
      this.editPatient = {
        positions: []
      }
      this.$emit('close')
    },
    listPosition: function (parent, best, sns, index) {
      if (!best) {
        best = 5
      }
      if (!index) {
        index = 0
      }
      if (parent && parent.leaf) {
        return
      }
      let self = this
      let sn = (!_.isEmpty(sns) && sns.length > index) ? sns[index] : null
      if (sn && parent && !_.isEmpty(parent.children)) {
        let chi = _.findIndex(parent.children, {'sn': sn})
        if (chi >= 0) {
          self.listPosition(parent.children[chi], best, sns, ++index)
        }
        return
      }
      if (!parent && !_.isEmpty(sns) && self.positionSelection.length > 0) {
        index = 0
        let chi = _.findIndex(self.positionSelection, {'sn': sns[index]})
        if (chi >= 0) {
          self.listPosition(self.positionSelection[chi], best, sns, ++index)
        }
        return
      }
      let level = parent ? (parent.level + 1) : 1
      PositionService.list({
        psn: parent ? parent.sn : null
      }).then(data => {
        data = data.result
        if (!_.isEmpty(data)) {
          let children = []
          for (let i = 0; i < data.length; i++) {
            let item = _.cloneDeep(data[i])
            item.index = i
            if (level >= best) {
              item.leaf = true
            } else {
              item.leaf = false
              item.children = []
            }
            children.push(item)
          }
          if (parent) {
            children = parent.children = _.clone(children)
          } else {
            children = self.positionSelection = _.clone(children)
          }
          if (sn) {
            let chi = _.findIndex(children, {'sn': sns[index]})
            if (chi >= 0) {
              self.listPosition(children[chi], best, sns, ++index)
            }
          }
        } else {
          if (parent) {
            parent.leaf = true
            delete parent.children
          }
        }
      }, () => {
        if (parent) {
          parent.leaf = true
          delete parent.children
        }
      })
    },
    changePatientPostion () {
      let self = this
      return new Promise((resolve) => {
        if (_.isEmpty(self.editPatient.positions)) {
          self.editPatient.provinceSn = null
          self.editPatient.province = null
          self.editPatient.citySn = null
          self.editPatient.city = null
          self.editPatient.countySn = null
          self.editPatient.county = null
          self.editPatient.townsSn = null
          self.editPatient.towns = null
          self.editPatient.villageSn = null
          self.editPatient.village = null
          resolve()
          return
        }
        PositionService.path({
          sn: _.last(self.editPatient.positions)
        }).then(res => {
          let data = res.result
          if (!_.isEmpty(data)) {
            self.editPatient.provinceSn = data[0] ? data[0].sn : null
            self.editPatient.province = data[0] ? data[0].name : null
            self.editPatient.citySn = data[1] ? data[1].sn : null
            self.editPatient.city = data[1] ? data[1].name : null
            self.editPatient.countySn = data[2] ? data[2].sn : null
            self.editPatient.county = data[2] ? data[2].name : null
            self.editPatient.townsSn = data[3] ? data[3].sn : null
            self.editPatient.towns = data[3] ? data[3].name : null
            self.editPatient.villageSn = data[4] ? data[4].sn : null
            self.editPatient.village = data[4] ? data[4].name : null
          } else {
            self.editPatient.provinceSn = null
            self.editPatient.province = null
            self.editPatient.citySn = null
            self.editPatient.city = null
            self.editPatient.countySn = null
            self.editPatient.county = null
            self.editPatient.townsSn = null
            self.editPatient.towns = null
            self.editPatient.villageSn = null
            self.editPatient.village = null
          }
        }).finally(() => {
          resolve()
        })
      })
    },
    savePatient () {
      let self = this
      self.patientSaving = true
      self.changePatientPostion().finally(() => {
        let _pat = _.cloneDeep(self.editPatient)
        delete _pat.positions
        if (_.isEqual(_pat, self.value)) {
          self.$message({
            message: '保存患者信息成功',
            type: 'success'
          })
          self.patientSaving = false
          this.$emit('saveDone', self.value)
          return
        }
        self.$refs['editPatientForm'].validate(valid => {
          if (valid) {
            let message = this.$message({
              message: '正在保存患者信息...',
              center: true,
              duration: 0
            })
            PatientService.save(_pat).then(res => {
              let data = res.result || null
              if (!data) {
                self.$message.error('保存患者信息失败')
                return
              }
              self.$message({
                message: '保存患者信息成功',
                type: 'success'
              })
              this.$emit('input', data)
              this.$emit('saveDone', data)
            }, err => {
              self.$message.error(err)
              this.$emit('error', err)
            }).finally(() => {
              message.close()
              self.patientSaving = false
            })
          } else {
            self.$message.error('表单验证失败!')
            self.patientSaving = false
          }
        })
      })
    },
    openCascader (val) {
      if (val) {
        this.$nextTick(() => {
        const lis = this.$refs.cascader.panel.$el.lastChild.querySelectorAll('li')
          _.forEach(lis, val => {
            if (val.className.indexOf('is-active') !== -1) {
              val.click()
            }
          })
        })
      }
    },
    upperCase (val) {
      this.editPatient.identity = val.toUpperCase()
    }
  }
}
</script>

<template>
  <el-form ref="editPatientForm" label-position="right" label-width="100px" :rules="patientRules" :model="editPatient" :disabled="patientSaving">
    <el-form-item label="姓名" prop="name">
      <el-input v-model="editPatient.name" placeholder="请输入患者姓名"></el-input>
    </el-form-item>
    <el-form-item label="身份证" prop="identity">
      <el-input v-model="editPatient.identity" @change="upperCase" placeholder="请输入患者身份证号"></el-input>
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      <el-radio-group v-model="editPatient.sex">
        <el-radio :label="parseInt(1)" border>男</el-radio>
        <el-radio :label="parseInt(2)" border>女</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="年龄" prop="age" v-if="!editPatient.identity">
      <el-input type="age" v-model.number="editPatient.age" placeholder="请输入患者年龄"></el-input>
    </el-form-item>
    <el-form-item label="手机号" prop="mobile">
      <el-input type="mobile" v-model.number="editPatient.mobile" placeholder="请输入患者手机号"></el-input>
    </el-form-item>
    <el-form-item label="住址">
      <el-cascader
        ref="cascader"
        @visible-change="openCascader"
        :options="positionSelection"
        :props="{checkStrictly: true, value: 'sn', label: 'name', children: 'children'}"
        clearable
        v-model="editPatient.positions"
        style="width: 100%;">
      </el-cascader>
    </el-form-item>
    <el-form-item label="详细地址" prop="house">
      <el-input v-model="editPatient.house" placeholder="请输入患者详细地址：xx幢xx单元xx室"></el-input>
    </el-form-item>
    <el-form-item v-if="showButtons">
      <el-button @click="handleCancelEditPatient">取消</el-button>
      <el-button type="primary" @click="savePatient()">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
